import { SingleLineManagerBody } from "./SingleLineManagerBody";
export default SingleLineManagerBody;
